import * as React from 'react';

const SvgConnectionrequest = (props) => (
  <svg
    width={56}
    height={56}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={4} y={4} width={48} height={48} rx={24} fill="#FEE1B6" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.0359 20.0273C25.0359 21.1338 24.139 22.0308 23.0325 22.0308C21.9261 22.0308 21.0291 21.1338 21.0291 20.0273C21.0291 18.9209 21.9261 18.0239 23.0325 18.0239C24.139 18.0239 25.0359 18.9209 25.0359 20.0273ZM23.0325 22.0308C21.3728 22.0308 20.0274 22.9277 20.0274 24.0342C20.0274 25.1406 21.3728 26.0376 23.0325 26.0376C24.6922 26.0376 26.0377 25.1406 26.0377 24.0342C26.0377 22.9277 24.6922 22.0308 23.0325 22.0308ZM34.0513 34.0513C35.1578 34.0513 36.0547 33.1543 36.0547 32.0479C36.0547 30.9414 35.1578 30.0444 34.0513 30.0444C32.9449 30.0444 32.0479 30.9414 32.0479 32.0479C32.0479 33.1543 32.9449 34.0513 34.0513 34.0513ZM34.0513 34.0513C35.711 34.0513 37.0565 34.9482 37.0565 36.0547C37.0565 37.1611 35.711 38.0581 34.0513 38.0581C32.3916 38.0581 31.0462 37.1611 31.0462 36.0547C31.0462 34.9482 32.3916 34.0513 34.0513 34.0513ZM27.2898 19.0256C27.2898 18.6107 27.6262 18.2744 28.0411 18.2744C33.4351 18.2744 37.8077 22.647 37.8077 28.041C37.8077 28.4559 37.4714 28.7923 37.0565 28.7923C36.6415 28.7923 36.3052 28.4559 36.3052 28.041C36.3052 23.4769 32.6052 19.7769 28.0411 19.7769C27.6262 19.7769 27.2898 19.4406 27.2898 19.0256ZM19.0257 27.2897C19.4406 27.2897 19.777 27.6261 19.777 28.041C19.777 32.6052 23.4769 36.3051 28.0411 36.3051C28.456 36.3051 28.7924 36.6415 28.7924 37.0564C28.7924 37.4713 28.456 37.8077 28.0411 37.8077C22.6471 37.8077 18.2744 33.435 18.2744 28.041C18.2744 27.6261 18.6108 27.2897 19.0257 27.2897Z"
      fill="#DC8400"
    />
    <rect
      x={4}
      y={4}
      width={48}
      height={48}
      rx={24}
      stroke="#FFF8F6"
      strokeWidth={8}
    />
  </svg>
);

export default SvgConnectionrequest;
